import {
  SET_TITLE, APP_SET_INSTALLED, APP_SET_ONLINE, APP_SET_OFFLINE,
} from '../constants/app.constants';

export const setTitleAction = title => ({
  type: SET_TITLE,
  payload: title,
});

export const setInstalledAction = () => ({
  type: APP_SET_INSTALLED,
});

export const setOnlineAction = () => ({
  type: APP_SET_ONLINE,
});

export const setOfflineAction = () => ({
  type: APP_SET_OFFLINE,
});
